<!-- Left panel: profile + primary navigation -->
<fuse-vertical-navigation
    class="dark bg-primary print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="data?.navigation?.default || []"
    [opened]="!isScreenSmall">
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex flex-col items-center w-full px-4 pt-6 pb-4" *ngIf="user">
            <div class="relative w-20 h-20">
                <img
                    class="w-full h-full rounded-full object-cover"
                    *ngIf="user.avatar"
                    [src]="user.avatar"
                    alt="User avatar">
                <mat-icon
                    class="icon-size-20 text-white"
                    *ngIf="!user.avatar"
                    [svgIcon]="'heroicons_solid:user-circle'"></mat-icon>
            </div>
            <div class="flex flex-col items-center w-full mt-4 text-white">
                <div class="w-full text-center font-semibold text-base truncate">
                    {{ user.fullname }}
                </div>
                <div class="w-full mt-1 text-center text-sm opacity-80 truncate">
                    {{ user.email }}
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container fuseVerticalNavigationContentFooter>
        <div class="pointer-events-none absolute inset-0 overflow-hidden opacity-10">
            <img class="w-full h-full object-contain object-right-bottom" [src]="watermarkPath" alt="">
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Main column -->
<div class="flex flex-col flex-auto w-full min-w-0 min-h-0">
    <div class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')" aria-label="Toggle navigation">
            <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
        </button>
        <div class="flex items-center pl-2 ml-auto space-x-1">
            <user-menu></user-menu>
            <fuse-fullscreen></fuse-fullscreen>
        </div>
    </div>

    <div class="flex flex-col flex-auto min-h-0">
        <router-outlet *ngIf="true"></router-outlet>
    </div>
</div>
